import { useQuery } from 'react-query'
import apiKey from 'src/core/services/base/apiKey'
import { getOrdersStatusCount } from '.'
import { useUnAuthAlert } from 'src/shared/hooks/useUnAuthAlert'

export default function useGetOrdersStatusCount(web_order_status: string) {
  const { openUnAuthAlertMemoWithContent } = useUnAuthAlert()
  const FetchFunction = () => getOrdersStatusCount(openUnAuthAlertMemoWithContent, web_order_status)

  const { data, isSuccess, isLoading } = useQuery([apiKey.getOrdersStatusCount, web_order_status], FetchFunction, {
    // refetchOnWindowFocus: true,
    keepPreviousData: false,
    retry: 3,
    enabled: web_order_status === '2' || web_order_status === '3',
  })

  return { data, isSuccess, isLoading }
}
